<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="18" height="18" viewBox="0 0 24 24" fill="none">                
    <path d="M20 7H3C2.44772 7 2 7.44772 2 8V16C2 16.5523 2.44771 17 3 17H20C20.5523 17 21 16.5523 21 16V8C21 7.44772 20.5523 7 20 7Z" stroke="#333333" stroke-width="1.25"/>
    <path d="M13 9H4V15H13V9Z" fill="#333333" stroke="#333333" stroke-width="1.25"/>
    <path d="M21 10.5V13.5C21 13.7761 21.2239 14 21.5 14C21.7761 14 22 13.7761 22 13.5V10.5C22 10.2239 21.7761 10 21.5 10C21.2239 10 21 10.2239 21 10.5Z" stroke="#333333" stroke-width="1.25"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
